import { inject, Injectable, signal, WritableSignal } from "@angular/core";
import { userStore } from "src/app/state/user.store";
import { LocalStorageService } from "../local-storage.service";
@Injectable({
  providedIn: "root"
})
export class TokenService {
  private readonly localStorageService = inject(LocalStorageService);
  private readonly userStore = inject(userStore);

  //--- !! il est conseillé de stocker le token dans un service et non dans le store ngrx
  private readonly token: WritableSignal<string> = signal<string>(this.localStorageService.getRefreshToken());
  private readonly selectedSimuCode: WritableSignal<string> = signal<string>(this.userStore.simulation()?.code);

  /**
   * récupère le token enregistré dans le service
   * @returns token
   */
  getToken(): string {
    return this.token();
  }

  /**
   * modifie le token enregistré dans le service
   * @param token token
   */
  setToken(token: string) {
    this.token.set(token);
    this.localStorageService.saveToken(token);
  }

  /**
   * récupère le code de simulation sélectionné
   */
  getSelectedSimuCode(): string {
    return this.selectedSimuCode();
  }

  /**
   * modifie le code de simulation enregistré dans le service
   * @param code code
   */
  setSelectedSimuCode(code: string) {
    this.selectedSimuCode.set(code);
  }
}
